import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { RuntimeService } from '../../shared/services/runtime.service';

export const chatAccessGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const runtime = inject(RuntimeService);
  const router = inject(Router);

  if (!runtime.IsDesktopApplication && authService.hasChatAccess()) {
    return true;
  }

  return router.createUrlTree(['/load-planning']);
};
